import { homeLinks } from '../../../data/homeLinks';

export interface QuickLink {
  id: string;
  title: string;
  url: string;
  icon?: string;
  order: number;
}

export const MAX_QUICK_LINKS = 25;

// Seeded from the existing curated homeLinks so first-time users see the
// same set as before this feature shipped.
export const DEFAULT_QUICK_LINKS: QuickLink[] = homeLinks.map((link, i) => ({
  id: link.label.toLowerCase().replace(/[^a-z0-9]+/g, '-'),
  title: link.label,
  url: link.url,
  order: i,
}));

export type ValidationError =
  | { type: 'too_many'; max: number; actual: number }
  | { type: 'invalid_url'; title: string; url: string }
  | { type: 'empty_title'; index: number };
